import { useMemo } from 'react';
import { Project, Competition } from '@brg/api';
import { AppTester } from 'supporting';

interface UseProjectCardCompetitionProps {
  project?: Project;
  showCompetitionPoint?: boolean;
  showCompetitionJuryPoint?: boolean;
  showFirstCompetitionPoint?: boolean;
  currentCompetitionId?: string;
  competition?: Competition<'Local'>;
}

export const useProjectCardCompetition = ({
  project,
  showCompetitionPoint,
  showCompetitionJuryPoint,
  showFirstCompetitionPoint,
  currentCompetitionId,
  competition,
}: UseProjectCardCompetitionProps) => {
  const isOnlines = AppTester.isOnlines();

  const competitionGPA = useMemo(() => {
    const roundValue = (value: any): number | undefined => {
      const num = typeof value === 'number' ? value : parseFloat(value);
      return isNaN(num) ? undefined : Math.round(num);
    };

    //@ts-ignore
    const isExam = competition?.lmsModuleProjectId;
    if (isExam && project) {
      return roundValue(project.competitonsGPA?.[0]?.competitionGPA);
    }

    if (showCompetitionPoint && !isOnlines && currentCompetitionId && project) {
      if (showCompetitionJuryPoint) {
        return project.competitionGPA;
      }

      const points = project.competitonsGPA?.find((x) => x.competitionId === currentCompetitionId);

      if (points) {
        return points.competitionGPA;
      }

      return undefined;
    } else if (project && showFirstCompetitionPoint) {
      return project.competitonsGPA?.[0]?.competitionGPA;
    } else {
      return undefined;
    }
  }, [
    showCompetitionPoint,
    showCompetitionJuryPoint,
    isOnlines,
    currentCompetitionId,
    project,
    showFirstCompetitionPoint,
    competition,
  ]);

  return {
    competitionGPA,
  };
};
import { useMemo } from 'react';
import { Project, Competition } from '@brg/api';
import { AppTester } from 'supporting';

interface UseProjectCardCompetitionProps {
  project?: Project;
  showCompetitionPoint?: boolean;
  showCompetitionJuryPoint?: boolean;
  showFirstCompetitionPoint?: boolean;
  currentCompetitionId?: string;
  competition?: Competition<'Local'>;
}

export const useProjectCardCompetition = ({
  project,
  showCompetitionPoint,
  showCompetitionJuryPoint,
  showFirstCompetitionPoint,
  currentCompetitionId,
  competition,
}: UseProjectCardCompetitionProps) => {
  const isOnlines = AppTester.isOnlines();

  const competitionGPA = useMemo(() => {
    const roundValue = (value: any): number | undefined => {
      const num = typeof value === 'number' ? value : parseFloat(value);
      return isNaN(num) ? undefined : Math.round(num);
    };

    //@ts-ignore
    const isExam = competition?.lmsModuleProjectId;
    if (isExam && project) {
      return roundValue(project.competitonsGPA?.[0]?.competitionGPA);
    }

    if (showCompetitionPoint && !isOnlines && currentCompetitionId && project) {
      if (showCompetitionJuryPoint) {
        return project.competitionGPA;
      }

      const points = project.competitonsGPA?.find((x) => x.competitionId === currentCompetitionId);

      if (points) {
        return points.competitionGPA;
      }

      return undefined;
    } else if (project && showFirstCompetitionPoint) {
      return project.competitonsGPA?.[0]?.competitionGPA;
    } else {
      return undefined;
    }
  }, [
    showCompetitionPoint,
    showCompetitionJuryPoint,
    isOnlines,
    currentCompetitionId,
    project,
    showFirstCompetitionPoint,
    competition,
  ]);

  return {
    competitionGPA,
  };
};
